import React, { useEffect, useState } from "react";
import "./KmlPage.css";
import feature1 from "../images/feature1-kml.jpg";
import feature2 from "../images/feature2-kml.jpg";
import feature3 from "../images/feature3-kml.png";
import feature4 from "../images/feature4.jpg";
import feature5 from "../images/feature5.png";
import feature6 from "../images/feature6.jpg";
import demokml from "../images/demo-kml.jpg";
import laptop from "../images/laptop.png";
import { FiTrendingUp, FiBox, FiDollarSign, FiZap } from "react-icons/fi";
import auctionImg from "../images/auction.jpg";
import inventoryImg from "../images/inventory.jpg";
import securityImg from "../images/security.jpg";
import complianceImg from "../images/compliance.jpg";
import analyticsImg from "../images/analytics.jpg";
import mobileImg from "../images/mobile.jpg";
import bgimageBusiness from "../images/bgimageBusiness.png";
import bgImagee from "../images/grandfather2.jpg";
import BASE_URL from "../apiConfig";

import useRecaptcha from "../hooks/useRecaptcha";


function KmlPage() {


  const [popupMessage, setPopupMessage] = useState("");
  const [popupWidgetId, setPopupWidgetId] = useState(null);
  const [mainWidgetId, setMainWidgetId] = useState(null);


  // ✅ EXTRA STATES
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ FULL INDIA STATES
  const indiaStates = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
    "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand",
    "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
    "Uttar Pradesh", "Uttarakhand", "West Bengal",
    "Delhi", "Jammu & Kashmir", "Ladakh", "Chandigarh", "Puducherry"
  ];

  // Sample city mapping (expand later if needed)
  const stateCities = {
    Kerala: ["Kochi", "Trivandrum", "Kozhikode", "Thrissur"],
    Karnataka: ["Bangalore", "Mysore", "Mangalore"],
    TamilNadu: ["Chennai", "Coimbatore", "Madurai"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur"],
    Delhi: ["New Delhi"]
  };



  // ✅ STATE
  const [showPopup, setShowPopup] = useState(false);

  const [formData, setFormData] = useState({
    full_name: "",
    phone: "",
    email: "",
    state: "",
    city: "",
    shop_name: "",
    challenges: ""
  });


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "state") {
      setFormData({
        ...formData,
        state: value,
        city: ""
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };


  // <!-- snehacaptcha -->

  // const handleSubmit = async (e, type = "main") => {
  //   e.preventDefault();

  //   if (!formData.full_name || !formData.phone) {
  //     const msg = "❌ Name, Phone are required.";
  //     type === "popup" ? setPopupMessage(msg) : setMessage(msg);
  //     return;
  //   }

  //   setLoading(true);

  //   try {

  //     // GENERATE CAPTCHA TOKEN
  //     const token = await window.grecaptcha.execute(
  //       "6LdC6OcqAAAAAPOMnCEpbCY7t54cRHG6XljUKvE8",
  //       { action: "submit" }
  //     );

  //     const fd = new FormData();

  //     Object.keys(formData).forEach((key) => {
  //       fd.append(key, formData[key]);
  //     });

  //     fd.append("_type", "kml_demo");
  //     fd.append("tk", btoa(token));   // send captcha token

  //     const response = await fetch(BASE_URL + "/DemoApi/saveData", {
  //       method: "POST",
  //       body: fd
  //     });

  //     const result = await response.json();

  //     if (result.status) {

  //       type === "popup"
  //         ? setPopupMessage("✅ Demo Request Submitted")
  //         : setMessage("✅ Demo Request Submitted");

  //       setFormData({
  //         full_name: "",
  //         phone: "",
  //         email: "",
  //         shop_name: "",
  //         challenges: ""
  //       });

  //     } else {
  //       setMessage("❌ " + result.message);
  //     }

  //   } catch (error) {
  //     console.error(error);
  //     setMessage("❌ Submission Failed");
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (window.grecaptcha) {
      // Main form rendering
      const mainContainer = document.getElementById("recaptcha-main-kml");
      if (mainContainer && mainContainer.innerHTML === "") {
        try {
          const id = window.grecaptcha.render(mainContainer, {
            // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
            sitekey: window.RECAPTCHA_SITE_KEY,
          });
          setMainWidgetId(id);
        } catch (err) {
          console.error("reCAPTCHA main render error:", err);
        }
      }

      // Popup form rendering
      if (showPopup) {
        const timer = setTimeout(() => {
          const popupContainer = document.getElementById("recaptcha-popup-kml");
          if (popupContainer && popupContainer.innerHTML === "") {
            try {
              const id = window.grecaptcha.render(popupContainer, {
                // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
                sitekey: window.RECAPTCHA_SITE_KEY,
              });
              setPopupWidgetId(id);
            } catch (err) {
              console.error("reCAPTCHA popup render error:", err);
            }
          }
        }, 500);
        return () => clearTimeout(timer);
      }
    }
  }, [showPopup]);

  const handleSubmit = async (e, type = "main") => {
    e.preventDefault();


    if (!formData.full_name || !formData.phone) {
      const msg = "❌ Name, Phone are required.";
      type === "popup" ? setPopupMessage(msg) : setMessage(msg);
      return;
    }

    setLoading(true);

    try {
      const token = type === "popup" ? getResponse(popupWidgetId) : getResponse(mainWidgetId);
      if (!token) {
        const errorMsg = "❌ Please complete the reCAPTCHA.";
        type === "popup" ? setPopupMessage(errorMsg) : setMessage(errorMsg);
        setLoading(false);
        return;
      }

      const fd = new FormData();

      Object.keys(formData).forEach(key => {
        fd.append(key, formData[key]);
      });

      fd.append("_type", "kml_demo");
      fd.append("tk", token);

      const response = await fetch(BASE_URL + "/DemoApi/saveData", {
        method: "POST",
        body: fd
      });

      const result = await response.json();

      if (result.status) {

        type === "popup"
          ? setPopupMessage("✅ Demo Request Submitted")
          : setMessage("✅ Demo Request Submitted");

        setFormData({
          full_name: "",
          phone: "",
          email: "",
          state: "",
          city: "",
          shop_name: "",
          challenges: ""
        });

      } else {
        const msg = "❌ " + (result.message || "Verification Failed");
        type === "popup" ? setPopupMessage(msg) : setMessage(msg);
      }

    } catch (error) {
      console.error("Submission Error:", error);
      const msg = "❌ Submission Failed. Check Console.";
      type === "popup" ? setPopupMessage(msg) : setMessage(msg);
    }

    setLoading(false);
  };
  // <!-- snehacaptcha -->













  // ✅ SCROLL DETECTION
  useEffect(() => {
    const handleScroll = () => {
      const statsSection = document.querySelector(".stats-section-kml");
      if (!statsSection) return;

      const rect = statsSection.getBoundingClientRect();

      if (rect.top <= window.innerHeight * 0.7) {
        setShowPopup(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const enterpriseSections = [
    {
      title: "Auction Management",
      image: auctionImg,
      features: [
        "Auction Eligibility Automation – Auto-identification of NPA accounts",
        "Auction Notice Generation – State-specific format & timelines",
        "Ornament Movement Tracking with custody logs",
        "Bid Management – Physical and online bidding support",
        "Post-Auction Settlement with recovery tracking"
      ]
    },
    {
      title: "Inventory & Audit Management",
      image: inventoryImg,
      features: [
        "Branch-wise and vault-wise ornament stock register",
        "Daily Gold Loan Index Report with LTV position",
        "Gold Takeover Management documentation",
        "Periodic audits with discrepancy reporting",
        "Insurance tracking and claim management"
      ]
    },
    {
      title: "Security & Control",
      image: securityImg,
      features: [
        "Biometric authorization for critical actions",
        "Maker-Checker approval workflow",
        // "CCTV-linked transaction timestamps",
        "Locker-linked transaction timestamps",
        "Access control logs for vault monitoring",
        // "Digital signatures for all agreements"
        "Camera and Face Detection integrated Gold pledge and release"
      ]
    },
    {
      title: "Regulatory & Compliance",
      image: complianceImg,
      features: [
        "Automated Daybook, Trialbalance and Balance Sheet",
        "Automated KML based Forms, receipts and reports",
        "SARFAESI and NPA notice generation & tracking",
        "KML reporting automation",
        "Data privacy compliance",
        "Complete audit trails",
        "GST & TDS automation"
      ]
    },
    {
      title: "Business Intelligence & Reporting",
      image: analyticsImg,
      features: [
        "Real-time portfolio dashboard",
        "Gold price impact analysis",
        "Customer repayment behavior insights",
        "Staff performance metrics",
        "Risk concentration reports"
      ]
    },
    {
      title: "Mobile & Digital Features",
      image: mobileImg,
      features: [
        "Field appraisal mobile app",
        "Customer mobile app",
        "WhatsApp business integration",
        "SMS alert automation",
        "Online customer document portal"
      ]
    }
  ];



  // testinomials


  useEffect(() => {
    const carousel = document.getElementById("miniCarousel");
    const prevBtn = document.getElementById("prevBtn");
    const nextBtn = document.getElementById("nextBtn");

    const cards = carousel.children;
    const totalCards = cards.length;

    let index = 0;

    function updateCarousel() {
      const cardWidth = carousel.children[0].offsetWidth;
      carousel.style.transform = `translateX(-${index * cardWidth}px)`;
    }

    nextBtn.onclick = () => {
      if (index < totalCards - 4) {
        index++;
        updateCarousel();
      }
    };

    prevBtn.onclick = () => {
      if (index > 0) {
        index--;
        updateCarousel();
      }
    };

  }, []);


  // testinomials



  return (
    <>
      {/* HERO SECTION */}





      <div
        className="bg-container"
        style={{ backgroundImage: `url(${bgImagee})` }}
      ></div>
      <div className="kml-wrapper">
        <div className="kml-left">
          <h1>IGNOSI- KML</h1>
          <h2>End-to-End Money Lending Lifecycle Platform</h2>
          <h3>Complete Gold Loan and Money Lending Lifecycle Management with AI & Automation</h3>

          <p>
            Manage pledges, valuations, auctions, and renewals with real-time gold price integration. Track ornament movements, automate auction eligibility, and monitor recovery—all with biometric release authorization and inventory-level reporting.
          </p>

          <ul>
            <li>AI-Powered Risk Mitigation</li>
            <li>Complete Regulatory Compliance</li>
            <li>Inventory-Level Security</li>
            <li>Flexible & Customer-Centric</li>
          </ul>
        </div>

        <div className="kml-right">
          <form className="demo-form-kml" onSubmit={handleSubmit}>

            <input
              type="text"
              name="full_name"
              placeholder="Full Name*"
              value={formData.full_name}
              onChange={handleChange}
            />

            <input
              type="text"
              name="phone"
              placeholder="Phone Number*"
              value={formData.phone}
              onChange={handleChange}
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
            />

            <input
              type="text"
              name="shop_name"
              placeholder="Organization Name(Optional)"
              value={formData.shop_name}
              onChange={handleChange}
            />

            <textarea
              name="challenges"
              placeholder="What challenges are you looking to solve?"
              value={formData.challenges}
              onChange={handleChange}
            />

            <div
              id="recaptcha-main-kml"
              style={{ marginBottom: "15px" }}
            ></div>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Book a Demo"}
            </button>

            {/* SUCCESS / ERROR MESSAGE */}
            {message && (
              <p style={{ marginTop: "15px", fontWeight: "600" }}>
                {message}
              </p>
            )}

          </form>
        </div>




      </div>









      {/* FEATURES SECTION */}
      <div className="features-section-kml">


        <div className="feature-card-kml">
          <div className="feature-image">
            <img src={feature4} alt="2" />
          </div>
          <div className="feature-bar">Payment & Repayment Flexibility</div>
          <div className="feature-hover">
            <ul>
              <li>Multiple Repayment Methods -EMI, EDI (Equal Daily Installment), EWI (Equal Weekly Installment)</li>
              <li>Part Payment Facility -Pay any amount anytime with interest recalculation</li>
              <li>Part Ornament Release -Release specific items after partial payment</li>
              <li>Auto-Debit Setu -NACH, SI, and UPI AutoPay integration</li>
              <li>Cash/Cheque/Online Paymen -Multiple payment modes with instant postings</li>
            </ul>
          </div>
        </div>

        <div className="feature-card-kml">
          <div className="feature-image">
            <img src={feature5} alt="2" />
          </div>
          <div className="feature-bar">Renewal & Enhancement Management</div>
          <div className="feature-hover">
            <ul>
              <li>Seamless Loan Renewal -Same loan number continuation with interest settlement</li>
              <li>New Loan with Old Closure -Fresh loan number with auto-closure of previous loan</li>
              <li>Top-up & Additional Loan -Increase loan amount against same ornaments</li>
              <li>Ornament Addition/Reduction -Modify collateral during loan tenure</li>
              <li>Interest Capitalization Option -Convert due interest into principal during renewal</li>
            </ul>
          </div>
        </div>

        <div className="feature-card-kml">
          <div className="feature-image">
            <img src={feature6} alt="2" />
          </div>
          <div className="feature-bar">NPA & Recovery Management</div>
          <div className="feature-hover">
            <ul>
              <li>Auto NPA Bucketing -30/60/90/180/365-day bucket classification</li>
              <li>Smart Communication Engine – Auto-SMS, WhatsApp, IVR calls based on bucket</li>
              <li>Field Visit Planning – Recovery agent assignment with GPS trackin</li>
              <li>Promise-to-Pay Tracking – With automated follow-up reminders</li>
              <li>Legal Case Tagging – SARFAESI, arbitration, and court case management</li>
            </ul>
          </div>
        </div>



        <div className="feature-card-kml">
          <div className="feature-image">
            <img src={feature1} alt="2" />
          </div>
          <div className="feature-bar">Loan Origination & Customer Onboarding</div>
          <div className="feature-hover">
            <ul>
              <li>Digital KYC & eSign –Aadhaar/ PAN verification with instant demographic validation</li>
              <li>AI-Powered Fake Gold Detection –Image analysis and weight-density discrepancy alerts</li>
              <li>Auto-Generated Loan Application –With customer photo, ornament images, and purity detail</li>
              <li>Video KYC Integration – Remote verification for doorstep gold loans</li>
              <li>Customer Risk Profiling – Based on credit history, repayment behavior, and transaction patterns</li>
            </ul>
          </div>
        </div>
        <div className="feature-card-kml">
          <div className="feature-image">
            <img src={feature2} alt="1" />
          </div>
          <div className="feature-bar">Dynamic Gold Loan Schemes</div>
          <div className="feature-hover">
            <ul>
              <li>Flexible Interest Methods – Reducing balance, flat rate, daily/monthly compoundin</li>
              <li>Configurable Loan-to-Value (LTV) – Purity-wise and category-wise LTV settings</li>
              <li>Multi-Tier Interest Rates – Loan amount slabs with different interest rates</li>
              <li>Charges & Fee Management – Appraisal charges, processing fees, insurance premium</li>
              <li>Holiday & Grace Period Settings – Configure non-working days and grace periods for interest</li>
            </ul>
          </div>
        </div>



        <div className="feature-card-kml">
          <div className="feature-image">
            <img src={feature3} alt="3" />
          </div>
          <div className="feature-bar">Ornament Management & Valuation</div>
          <div className="feature-hover">
            <ul>
              <li>Real-Time Gold Price Integration – Multiple source integration (IBJA, MCX, local market)</li>
              <li>Purity-wise Valuation – 22K, 18K, 14K, and custom purity settings</li>
              <li>Ornament Image Catalog – Upload and tag images with weight and descriptio</li>
              <li>Barcode/RFID Tagging – Unique identification for each ornament packet</li>
              <li>Stock Movement Tracking – From receipt to vault, release, or auction</li>
            </ul>
          </div>
        </div>

      </div>





      {/* WHY IGNOSI SECTION */}
      <div className="why-ignosi-section">
        <h2 className="why-title">Why IGNOSI for Gold Loan Companies?</h2>
        <p className="why-subtitle">
          {/* Built exclusively for jewellers who want more than accounting —
          IGNOSI focuses on profitability, control, and long-term growth. */}
        </p>

        <div className="why-grid-kml">

          <div className="why-card">
            <div className="why-icon">✔️</div>
            <h3>AKPBA Approved Technology</h3>
            <p>
              Authorized technology provider of All Kerala Private Bankers Association (AKPBA)
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">🛡️</div>
            <h3>AI-Powered Risk Mitigation</h3>
            <p>
              Fake gold detection and fraud prevention
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">🏛️</div>
            <h3>Complete Regulatory Compliance</h3>
            <p>
              SARFAESI, RBI, and state regulations
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">🔒</div>
            <h3>Inventory-Level Security</h3>
            <p>
              From receipt to release with biometric controls
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">🤝</div>
            <h3>Flexible & Customer-Centric</h3>
            <p>
              Multiple repayment and renewal options
            </p>
          </div>

          <div className="why-card">
            <div className="why-icon">🏗️</div>
            <h3>Scalable Architecture</h3>
            <p>
              From single branch to pan-India operations
            </p>
          </div>

        </div>
      </div>






      {/* STATS SECTION */}
      <div className="stats-section-kml">
        <h2 className="stats-title">Trusted by Gold Loan Businesses Across India</h2>
        <div className="stats-grid-kml">
          <div className="stat-card"><div className="stat-icon">💎</div><h3>1600+</h3><p>kml companies Using Our Software</p></div>
          <div className="stat-card"><div className="stat-icon">📦</div><h3>5M+</h3><p>Ornaments Managed Digitally</p></div>
          <div className="stat-card"><div className="stat-icon">💰</div><h3>₹500Cr+</h3><p>Transactions Processed Monthly</p></div>
          <div className="stat-card"><div className="stat-icon">⚡</div><h3>99.9%</h3><p>System Uptime & Reliability</p></div>
        </div>
      </div>















      {/* PROFIT INTELLIGENCE DASHBOARD */}
      {/* <div className="profit-section-kml"> */}


      {/* <div
        className="profit-section-kml"
        style={{
          backgroundImage: `url(${bgimageBusiness})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      > */}


      {/* 
        <h2 className="profit-title">Business Intelligence & Performance Insights</h2>
        <p className="profit-subtitle">
          Real-time insights that help optimize repayments, renewals, and recovery performance
        </p> */}

      {/* <div className="profit-grid"> */}

      {/* COLUMN 1 */}
      {/* <div className="profit-card">
            <h3>Payment & Repayment Flexibility</h3>
            <ul>
              <li><strong>Multiple Repayment Methods</strong> -EMI, EDI (Equal Daily Installment), EWI (Equal Weekly Installment)</li>
              <li><strong>Part Payment Facility</strong> -Pay any amount anytime with interest recalculation</li>
              <li><strong>Part Ornament Release</strong> -Release specific items after partial payment</li>
              <li><strong>Auto-Debit Setu</strong> -NACH, SI, and UPI AutoPay integration</li>
              <li><strong>Cash/Cheque/Online Paymen</strong> -Multiple payment modes with instant posting</li>
            </ul>
          </div> */}

      {/* COLUMN 2 */}
      {/* <div className="profit-card">
            <h3>Renewal & Enhancement Management</h3>
            <ul>
              <li><strong>Seamless Loan Renewal</strong> -Same loan number continuation with interest settlement</li>
              <li><strong>New Loan with Old Closure</strong> -Fresh loan number with auto-closure of previous loa</li>
              <li><strong>Top-up & Additional Loan</strong> -Increase loan amount against same ornaments</li>
              <li><strong>Ornament Addition/Reduction</strong> -Modify collateral during loan tenure</li>
              <li><strong>Interest Capitalization Option</strong> -Convert due interest into principal during renewal</li>
            </ul>
          </div> */}

      {/* COLUMN 3 */}
      {/* <div className="profit-card">
            <h3>NPA & Recovery Management</h3>
            <ul>
              <li><strong>Auto NPA Bucketing</strong> -30/60/90/180/365-day bucket classification</li>
              <li><strong>Smart Communication Engine</strong> – Auto-SMS, WhatsApp, IVR calls based on bucket</li>
              <li><strong>Field Visit Planning</strong> – Recovery agent assignment with GPS tracking</li>
              <li><strong>Promise-to-Pay Tracking</strong> – With automated follow-up reminders</li>
              <li><strong>Legal Case Tagging</strong> – SARFAESI, arbitration, and court case management</li>
            </ul>
          </div> */}

      {/* </div>
      </div> */}




      {/* testinomilas */}
      {/* ================= FULL WIDTH TESTIMONIALS ================= */}

      <div className="full-testimonials-section-jewel">

        <h2 className="full-title-jewel">Trusted by Kml owners</h2>

        <div className="full-carousel-wrapper-jewel">

          <button className="full-arrow-jewel left" id="prevBtn">
            ‹
          </button>

          <div className="full-carousel-viewport-jewel">
            <div className="full-carousel-jewel" id="miniCarousel">

              {/* CARD 1 */}
              <div className="full-card-jewel">
                <div className="full-card-inner-jewel">
                  <div
                    className="full-video-jewel"
                    onClick={(e) => {
                      e.currentTarget.innerHTML = `
              
                      <iframe width="560" height="315" src="https://www.youtube.com/embed/HxTooqYGIkw?si=CGKcfPjHQku_1yYr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;

                    }}
                  >
                    <img
                      src="https://img.youtube.com/vi/YOUR_VIDEO_ID/hqdefault.jpg"
                      alt="Video"
                    />
                    <div className="play-btn-jewel">▶</div>
                    <h4>Real Customer Feedback</h4>
                  </div>

                </div>
              </div>

              {/* CARD 2 */}
              <div className="full-card-jewel">
                <div className="full-card-inner-jewel">
                  <div className="stars-jewel">★★★★★</div>
                  <p>“We have been using Ignosi Software for the past four years. It is simple, user-friendly, and provides accurate compliance reports. The customer support team is highly responsive and dependable. I confidently recommend Ignosi Software.”</p>
                  <h4>Mr. Shivaraj</h4>
                  <h5>Director – Sreenidhi Fin Venturesj</h5>
                </div>
              </div>

              {/* CARD 3 */}
              <div className="full-card-jewel">
                <div className="full-card-inner-jewel">
                  <div className="stars-jewel">★★★★★</div>
                  <p>“Ignosi Software is highly user-friendly and easy to operate. The team promptly provides new updates and improvements whenever required. Their continuous support and timely enhancements make the system very reliable for our daily operations.”</p>
                  <h4>Mr. Baiju Chacko</h4>
                  <h5>Proprietor – Golden Max Finance</h5>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="full-card-jewel">
                <div className="full-card-inner-jewel">
                  <div className="stars-jewel">★★★★★</div>
                  <p>“We have been associated with Ignosi Software for the past two years, and I am fully satisfied with the system and support. The software is reliable, easy to use, and perfectly suited for our financial operations.”</p>
                  <h4>Mr. George Joseph</h4>
                  <h5>Proprietor – Souparnika Finance</h5>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="full-card-jewel">
                <div className="full-card-inner-jewel">
                  <div className="stars-jewel">★★★★★</div>
                  <p>“We have been using Ignosi Software for the past three years, and it has proven to be a perfect solution for our financial operations. The system is thoughtfully designed, aligning well with practical business requirements and compliance standards. We truly appreciate the quality and reliability of the software.”</p>
                  <h4>Mr. Shiju Abraham</h4>
                  <h5>Proprietor – Sterling Fincorp, Idukki</h5>
                </div>
              </div>

              {/* CARD 4 */}
              <div className="full-card-jewel">
                <div className="full-card-inner-jewel">
                  <div className="stars-jewel">★★★★★</div>
                  <p>“More than two years of smooth experience with Ignosi Software. Highly user-friendly and strongly recommended.”</p>
                  <h4>Mr. Navaf Hamza</h4>
                  <h5>Proprietor – Kannamkammali Finance</h5>
                </div>
              </div>


            </div>
          </div>

          <button className="full-arrow-jewel right" id="nextBtn">
            ›
          </button>

        </div>
        {/* LOGO STRIP */}
        {/* <div className="logo-strip-full-jewel"> */}

        {/* <img src="/images/logo2.jpg" alt="client" />
          <img src="/images/logo3.png" alt="client" />
          <img src="/images/logo3.png" alt="client" />
          <img src="/images/logo3.png" alt="client" />
          <img src="/images/logo3.png" alt="client" />
          <img src="/images/logo4.png" alt="client" />
          <img src="/images/logo5.png" alt="client" />
          <img src="/images/logo6.jpeg" alt="client" />
          <img src="/images/logo6.jpeg" alt="client" />
          <img src="/images/logo6.jpeg" alt="client" />
          <img src="/images/logo6.jpeg" alt="client" />
          <img src="/images/logo6.jpeg" alt="client" />
          <img src="/images/logo6.jpeg" alt="client" /> */}
        {/* </div> */}

      </div>


      <div className="enterprise-modern-section">

        <h2 className="enterprise-modern-title">
          Enterprise Features Built for Modern Gold Loan Operations
        </h2>

        <div className="enterprise-modern-container">

          {enterpriseSections.map((item, index) => (
            <div
              className={`enterprise-row ${index % 2 !== 0 ? "reverse" : ""}`}
              key={index}
            >
              <div className="enterprise-image">
                <img src={item.image} alt={item.title} />
              </div>

              <div className="enterprise-content">
                <h3>{item.title}</h3>
                <ul>
                  {item.features.map((f, i) => (
                    <li key={i}>{f}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}

        </div>
      </div>



      {/* testinomilas */}











      {/* ENTERPRISE FEATURES SECTION */}
      {/* ENTERPRISE CAPABILITIES – SCREENSHOT STYLE */}
      {/* ENTERPRISE CAPABILITIES – WITH ICONS */}
      {/* <div className="enterprise-clean-section-kml">

        <h2 className="enterprise-clean-title">
          Enterprise-Grade Capabilities for Modern Jewellers
        </h2>

        <p className="enterprise-clean-subtitle">
          IGNOSI combines accounting, analytics, security, and mobility into one
          powerful platform built exclusively for jewellery businesses.
        </p>

        <div className="enterprise-clean-content"> */}

      {/* LEFT – SOFTWARE IMAGE */}
      {/* <div className="enterprise-clean-image">
            <img src={laptop} alt="IGNOSI Enterprise Dashboard" />
          </div> */}

      {/* RIGHT – FEATURES */}
      {/* <div className="enterprise-clean-features">

            <div className="enterprise-feature">
              <span className="enterprise-icon">💼</span>
              <div>
                <h4>Financial & Accounting Integration</h4>
                <p>
                  Automated accounting across purchases, sales, stock, banking,
                  expenses, P&L reporting, and GST compliance.
                </p>
              </div>
            </div> */}

      {/* <div className="enterprise-feature">
              <span className="enterprise-icon">📊</span>
              <div>
                <h4>Advanced Business Analytics</h4>
                <p>
                  Daily business snapshots, inventory turnover, customer lifetime
                  value, wastage tracking, and demand forecasting.
                </p>
              </div>
            </div>

            <div className="enterprise-feature">
              <span className="enterprise-icon">🔐</span>
              <div>
                <h4>Security & Control Features</h4>
                <p>
                  Biometric authentication, CCTV-linked transactions, role-based
                  access, audit trails, and automated backups.
                </p>
              </div>
            </div>

            <div className="enterprise-feature">
              <span className="enterprise-icon">☁️</span>
              <div>
                <h4>Mobile & Cloud Capabilities</h4>
                <p>
                  Mobile stock access, remote sales apps, cloud synchronization,
                  customer apps, and WhatsApp integration.
                </p>
              </div>
            </div>

            <div className="enterprise-feature">
              <span className="enterprise-icon">💎</span>
              <div>
                <h4>Specialized Jewellery Modules</h4>
                <p>
                  Hallmarking management, loan against stock, showroom management,
                  loyalty programs, and repair tracking.
                </p>
              </div>
            </div>

            <div className="enterprise-feature">
              <span className="enterprise-icon">📈</span>
              <div>
                <h4>Comprehensive Reporting Suite</h4>
                <p>
                  Stock valuation, profit margin analysis, metal rate impact,
                  sales dashboards, and inventory health reports.
                </p>
              </div>
            </div>

          </div>
        </div>
      </div> */}





      {/* ✅ POPUP MODAL */}
      {showPopup && (
        <div className="demo-popup-overlay">
          <div className="demo-popup">
            <button className="close-btn" onClick={() => setShowPopup(false)}>✕</button>

            <div className="popup-content">
              <div className="popup-image">
                {/* <img src="/images/demo-kml.jpg" alt="Jewellery Software Demo" /> */}
                <img src={demokml} alt="2" />
              </div>

              {/* <div className="popup-form">
                <h2>Jewellery Software Free Demo</h2>

                <div className="popup-grid">
                  <input type="text" placeholder="Enter Name" />
                  <input type="email" placeholder="Enter Email ID" />
                  <input type="text" placeholder="Enter Phone No." />
                  <input type="text" placeholder="Enter City" />
                </div>

                <textarea placeholder="What challenges are you looking to solve?" />

                <label className="popup-checkbox">
                  <input type="checkbox" /> I agree to receive updates about Ignosi
                </label>

                <button className="popup-submit">Book Free Demo</button>
              </div> */}


              <div className="popup-form-kml">
                <form onSubmit={(e) => handleSubmit(e, "popup")}>

                  <div className="popup-grid">

                    <input
                      type="text"
                      name="full_name"
                      placeholder="Name*"
                      value={formData.full_name}
                      onChange={handleChange}
                    />

                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone No.*"
                      value={formData.phone}
                      onChange={handleChange}
                    />

                    <input
                      type="email"
                      name="email"
                      placeholder="Email ID"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <input
                      type="text"
                      name="shop_name"
                      placeholder="Jewellery Name(Optional)"
                      value={formData.shop_name}
                      onChange={handleChange}
                    />

                  </div>

                  <textarea
                    name="challenges(Optional)"
                    placeholder="What challenges are you looking to solve?"
                    value={formData.challenges}
                    onChange={handleChange}
                  />

                  <label className="popup-checkbox">
                    <input type="checkbox" defaultChecked /> I authorise Ignosi to contact me via phone, email, or WhatsApp.
                  </label>

                  <div
                    id="recaptcha-popup-kml"
                    style={{ marginBottom: "15px" }}
                  ></div>

                  <button className="popup-submit-kml" disabled={loading}>
                    {loading ? "Submitting..." : "Book Free Demo"}
                  </button>

                  {popupMessage && (
                    <p style={{ marginTop: "10px", fontWeight: "600" }}>
                      {popupMessage}
                    </p>
                  )}

                </form>
              </div>
            </div>
          </div>
        </div>
      )}





    </>
  );
}

export default KmlPage;
